export let MAINTENANCE_TYPE = /*#__PURE__*/function (MAINTENANCE_TYPE) {
  MAINTENANCE_TYPE["NONE"] = "maintenance-none";
  MAINTENANCE_TYPE["NO_CAPABILITIES_DISRUPTION"] = "no-disruption";
  MAINTENANCE_TYPE["WITH_CAPABILITIES_DISRUPTION"] = "with-disruption";
  return MAINTENANCE_TYPE;
}({});
export let MAINTENANCE_STATE = /*#__PURE__*/function (MAINTENANCE_STATE) {
  MAINTENANCE_STATE["SCHEDULED"] = "scheduled";
  MAINTENANCE_STATE["IN_PROGRESS"] = "in-progress";
  return MAINTENANCE_STATE;
}({});
export let MAINTENANCE_BANNER_TARGET_PAGES = /*#__PURE__*/function (MAINTENANCE_BANNER_TARGET_PAGES) {
  MAINTENANCE_BANNER_TARGET_PAGES["ALL"] = "all";
  MAINTENANCE_BANNER_TARGET_PAGES["MARKETPLACE_PARTNER_PORTAL"] = "marketplace-partner-portal";
  return MAINTENANCE_BANNER_TARGET_PAGES;
}({});
export const MaintenanceNone = {
  type: MAINTENANCE_TYPE.NONE,
  content: ''
};